import React from "react";
import {
  ArrowUpDown,
  Ban,
  CheckCircle2,
  Clock,
  LayoutGrid,
  Share2,
  Sparkles,
  Timer,
} from "lucide-react";
import AdminFiltersRail, {
  AdminFilterSection,
  AdminNavFilterItem,
} from "../components/AdminFiltersRail";
import { REFERRAL_DESK_VIEWS, REFERRAL_SORT_OPTIONS } from "./constants";

const DESK_ICONS = {
  all: LayoutGrid,
  pending: Clock,
  ready: Sparkles,
  rewarded: CheckCircle2,
  cancelled: Ban,
};

const SORT_ICONS = {
  newest: Clock,
  oldest: Timer,
  progress: Sparkles,
  amount: Share2,
  referrer: Share2,
};

export default function AdminReferralsFiltersRail({
  desk,
  sortKey,
  summary,
  onDeskChange,
  onSortChange,
  onClear,
  activeCount,
  compact,
  onClose,
}) {
  const deskCounts = {
    all: summary?.all,
    pending: summary?.pending,
    ready: summary?.ready,
    rewarded: summary?.rewarded,
    cancelled: summary?.cancelled,
  };

  const summaryCopy = [
    summary?.total != null ? `${summary.total} in view` : null,
    activeCount ? `${activeCount} filter${activeCount === 1 ? "" : "s"} on` : null,
  ]
    .filter(Boolean)
    .join(" · ");

  return (
    <AdminFiltersRail
      title="Referrals desk"
      subtitle="Codes · unlocks · payouts"
      deskIcon={Share2}
      compact={compact}
      onClose={onClose}
      activeCount={activeCount}
      onClear={onClear}
      summaryCount={summary?.total}
      summaryCopy={summaryCopy || undefined}
    >
      <AdminFilterSection label="Desk" labelIcon={Share2}>
        {REFERRAL_DESK_VIEWS.map((v) => (
          <AdminNavFilterItem
            key={v.id}
            active={desk === v.id}
            onClick={() => onDeskChange(v.id)}
            icon={DESK_ICONS[v.id]}
            label={v.label}
            hint={v.hint}
            count={deskCounts[v.id] ?? null}
            countTone={v.id === "ready" && summary?.ready ? "warn" : undefined}
            urgent={v.id === "ready" && summary?.ready > 0}
          />
        ))}
      </AdminFilterSection>

      <AdminFilterSection label="Sort" labelIcon={ArrowUpDown}>
        {REFERRAL_SORT_OPTIONS.map((opt) => (
          <AdminNavFilterItem
            key={opt.value}
            active={sortKey === opt.value}
            onClick={() => onSortChange(opt.value)}
            icon={SORT_ICONS[opt.value] || Clock}
            label={opt.label}
          />
        ))}
      </AdminFilterSection>
    </AdminFiltersRail>
  );
}
